import { Link } from 'react-router-dom'
import { ShoppingBag } from 'lucide-react'

export function EmptyCart({ onClose }: { onClose?: () => void }) {
  return (
    <div className="py-16 text-center px-6">
      <div className="w-20 h-20 mx-auto rounded-full bg-brand-50 flex items-center justify-center text-brand-600 mb-4">
        <ShoppingBag className="w-10 h-10" />
      </div>
      <h3 className="text-lg font-semibold text-text">Giỏ hàng trống</h3>
      <p className="text-sm text-muted mt-1">Bạn chưa có sản phẩm nào trong giỏ.</p>
      <Link
        to="/"
        onClick={onClose}
        className="mt-5 inline-flex items-center justify-center h-11 px-6 rounded-full bg-brand-600 hover:bg-brand-700 text-white font-semibold text-sm transition"
      >
        Mua sắm ngay
      </Link>
    </div>
  )
}
